
export const initialState = {
    x: null,
    y: null,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case "SET_XY": {
            return {
                ...state,
                x: action.x,
                y: action.y
            };
        }

        default:
            return state;
    }
};
